import { Country } from '@afterpaytouch/portal-api/types'
import { CheckoutMerchantDetails, validateLocale } from '../../model'

export interface CountryRedirectionParams {
  shippingCountryCode?: Country
  billingCountryCode?: Country
  merchant: CheckoutMerchantDetails
  currentCountry: Country
}

const isSupportedCountry = (merchant: CheckoutMerchantDetails, newCountry: Country): boolean => {
  return merchant.supportedCountries.includes(newCountry)
}

export const determineRedirectCountry = (params: CountryRedirectionParams): Country | undefined => {
  const { shippingCountryCode, billingCountryCode, merchant, currentCountry } = params

  const newCountry = billingCountryCode ?? shippingCountryCode

  if (!newCountry) {
    return undefined
  }

  const newLocale = validateLocale('any', newCountry)
  const currentLocale = validateLocale('any', currentCountry)

  if (currentLocale !== newLocale && isSupportedCountry(merchant, newCountry)) {
    return newCountry
  }

  return undefined
}
